import InspectOrderPage from "./InspectOrderPage.vue";
export default InspectOrderPage;
